var map = {
	"./widgetimg/appsPreview.png": 1332,
	"./widgetimg/calendarPreview.png": 1333,
	"./widgetimg/chart01Preview.png": 516,
	"./widgetimg/chart02Preview.png": 1334,
	"./widgetimg/chart03Preview.png": 1335,
	"./widgetimg/chart04Preview.png": 1336,
	"./widgetimg/chart05Preview.png": 1337,
	"./widgetimg/guidePreview.png": 1338,
	"./widgetimg/linkPreview.png": 1339,
	"./widgetimg/messagePreview.png": 1340,
	"./widgetimg/othericonPreview.png": 517
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1331;